// eslint-disable-next-line import/no-cycle
import NetworkContent from '@/helpers/networking/NetworkContent';
import NetworkAssessment from '@/helpers/networking/NetworkAssessment';
// eslint-disable-next-line import/no-cycle
import ContentStore from '@/store/modules/content';

export default {
  state: {
    selectedDate: null,
    selectedHours: null,
    selectedMinutes: null,
    archivedTasks: [],
    createdTasks: [],
    kssParticipants: [],
    kssTeams: [],
    involvedKssUsers: [],
    newMeetingSubject: '',
    newDescription: '',
    errorFlag: false,
    isRecurringTask: false,
    recurringType: 'daily',
    recurringSubtype: 'days',
    recurringEveryX: 1,
    recurringWeekOfMonth: 2,
    includeWeekends: false,
    seriesEndDate: null,
    recurringDays: [],
    showRuntime: true,
    showCalendar: true,
    inviteEmails: [],
    similarTasks: null,
    hasSimilarTasks: false,
  },
  getters: {
    getSelectedDate: (state) => state.selectedDate,
    getKssParticipants: (state) => state.kssParticipants,
    getKssTeams: () => ContentStore.state.teams,
    getInvolvedKssUsers: (state) => state.involvedKssUsers,
    getSelectedKssParticipantCount:
      (state) => state.kssParticipants.filter((e) => e.isChecked).length,
    getRecurringDays: (state) => state.recurringDays,
    getRecurringWeekOfMonth: (state) => state.recurringWeekOfMonth,
    getIncludeWeekends: (state) => state.includeWeekends,
    getSeriesEndDate: (state) => state.seriesEndDate,
    getIsRecurringTask: (state) => state.isRecurringTask,
    getInviteEmails: (state) => state.inviteEmails,
    getCurrentArchivedTasks: (state) => state.archivedTasks,
    getCurrentCreatedTasks: (state) => state.createdTasks,
    getMinCount: (state) => state.minCount,
    getSelectedTime: (state) => `${(`0${state.selectedHours}`).slice(-2)}:${(`0${state.selectedMinutes}`).slice(-2)}`,
  },
  mutations: {
    setShowCalendar: (state, value) => {
      state.showCalendar = value;
    },
    setShowRuntime: (state, value) => {
      state.showRuntime = value;
    },
    setSelectedDate: (state, date) => {
      state.selectedDate = new Date(date);
    },
    setSelectedTime: (state, time) => {
      const hours = time.split(':')[0];
      const minutes = time.split(':')[1];
      state.selectedHours = Number(hours);
      state.selectedMinutes = Number(minutes);
    },
    setKssParticipants: (state, data) => {
      state.kssParticipants = [];
      data.users.forEach((el) => {
        state.kssParticipants.push({
          _id: el.id,
          name: el.name,
          teams: el.teams,
          isChecked: el.name === data.loggedInName,
        });
      });
    },
    setArchivedTasks: (state, data) => {
      state.archivedTasks = data;
    },
    setCreatedTasks: (state, data) => {
      state.createdTasks = data;
    },
    setMinCount: (state, data) => {
      state.minCount = data;
    },
    setInvolvedKssUsers: (state, data) => {
      state.involvedKssUsers = data;
    },
    setNewSubject: (state, newSubject) => {
      state.newMeetingSubject = newSubject;
    },
    setNewDescription: (state, newDescription) => {
      state.newDescription = newDescription;
    },
    setIsRecurringTask: (state, value) => {
      state.isRecurringTask = value;
    },
    setRecurringType: (state, value) => {
      const next = value && typeof value === 'object' && value.value != null ? value.value : value;
      state.recurringType = next;
      if (!state.recurringDays?.length) {
        state.recurringDays = [
          { rSchName: 'MO', isSelected: false },
          { rSchName: 'TU', isSelected: false },
          { rSchName: 'WE', isSelected: false },
          { rSchName: 'TH', isSelected: false },
          { rSchName: 'FR', isSelected: false },
          { rSchName: 'SA', isSelected: false },
          { rSchName: 'SU', isSelected: false },
        ];
      }
      if (next === 'monthly' || next === 'weekly') {
        const anySelected = state.recurringDays.some((day) => day.isSelected);
        if (!anySelected || next === 'monthly') {
          const anchor = state.selectedDate ? new Date(state.selectedDate) : new Date();
          const dayCodes = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'];
          const code = dayCodes[anchor.getDay()];
          state.recurringDays.forEach((day) => {
            day.isSelected = day.rSchName === code;
          });
        }
      }
    },
    setRecurringWeekOfMonth: (state, value) => {
      state.recurringWeekOfMonth = value;
    },
    setRecurringSubtype: (state, value) => {
      state.recurringSubtype = value;
    },
    setRecurringEveryX: (state, value) => {
      state.recurringEveryX = value;
    },
    setIncludeWeekends: (state, value) => {
      state.includeWeekends = !!value;
    },
    setSeriesEndDate: (state, value) => {
      state.seriesEndDate = value ? new Date(value) : null;
    },
    setSimilarTasks: (state, value) => {
      state.hasSimilarTasks = !!value;
      state.similarTasks = value;
    },
    initRecurringDays: (state) => {
      state.recurringDays = [
        {
          rSchName: 'MO',
          isSelected: false,
        },
        {
          rSchName: 'TU',
          isSelected: false,
        },
        {
          rSchName: 'WE',
          isSelected: false,
        },
        {
          rSchName: 'TH',
          isSelected: false,
        },
        {
          rSchName: 'FR',
          isSelected: false,
        },
        {
          rSchName: 'SA',
          isSelected: false,
        },
        {
          rSchName: 'SU',
          isSelected: false,
        },
      ];
    },
    selectRecurringDate: (state, index) => {
      state.recurringDays[index].isSelected = !state.recurringDays[index].isSelected;
    },
    selectRecurringDateMonthly: (state, index) => {
      state.recurringDays.forEach((day, i) => {
        day.isSelected = i === index;
      });
    },
    updateKssTeamSelection: (state, index) => {
      state.kssTeams = ContentStore.state.teams;
      state.kssTeams[index].isChecked = !state.kssTeams[index].isChecked;
      state.kssParticipants.forEach((kssParticipant, i) => {
        if (kssParticipant.teams.includes(state.kssTeams[index]._id)) {
          state.kssParticipants[i].isChecked = state.kssTeams[index].isChecked;
        }
      });
    },
    updateKssParticipantSelection: (state, index) => {
      state.kssParticipants[index].isChecked = !state.kssParticipants[index].isChecked;
      // uncheck selected team, if a participant is unchecked and belongs to that team
      if (!state.kssParticipants[index].isChecked) {
        state.kssTeams.forEach((team, i) => {
          if (state.kssParticipants[index].teams.includes(team._id)) {
            state.kssTeams[i].isChecked = false;
          }
        });
      }
    },
    /** Align participant/team checkboxes with a task's involvedUsers when opening the edit panel. */
    syncKssEditSelectionFromInvolvedUserIds: (state, userIds) => {
      const set = new Set((userIds || []).map((id) => String(id)));
      state.kssParticipants.forEach((p, i) => {
        state.kssParticipants[i].isChecked = set.has(String(p._id));
      });
      state.kssTeams = ContentStore.state.teams;
      const teams = ContentStore.state.teams;
      if (!teams?.length) {
        return;
      }
      teams.forEach((team, index) => {
        const rosterInTeam = state.kssParticipants.filter(
          (p) => Array.isArray(p.teams) && p.teams.map(String).includes(String(team._id)),
        );
        const shouldCheck = rosterInTeam.length > 0 && rosterInTeam.every((p) => p.isChecked);
        teams[index].isChecked = shouldCheck;
      });
    },
    addInviteEmail: (state, emails) => {
      if (emails !== undefined) {
        // Filter out duplicates - only add emails that don't already exist
        const uniqueNewEmails = emails.filter(
          (email) => !state.inviteEmails.includes(email.toLowerCase()),
        );
        state.inviteEmails.push(...uniqueNewEmails);
      }
    },
    removeInviteEmail: (state, index) => {
      state.inviteEmails.splice(index, 1);
    },
    popInviteEmail: (state) => {
      state.inviteEmails.pop();
    },
    removeKssParticipants: (state) => {
      state.kssParticipants = [];
    },
    removeArchivedTasks: (state) => {
      state.archivedTasks = [];
    },
    removeCreatedTasks: (state) => {
      state.createdTasks = [];
    },
    removeKssTeams: (state) => {
      state.kssTeams = [];
    },
    resetInviteEmail: (state) => {
      state.inviteEmails = [];
    },
    resetKssFormValues: (state) => {
      state.selectedDate = null;
      state.newDescription = '';
      state.newMeetingSubject = '';
    },
    resetKssRecurringTaskValues: (state) => {
      state.recurringEveryX = 1;
      state.recurringType = 'daily';
      state.recurringSubtype = 'days';
      state.recurringWeekOfMonth = 2;
      state.includeWeekends = false;
      state.seriesEndDate = null;
      state.isRecurringTask = false;
    },
  },
  actions: {
    async getArchivedTasks({ commit }) {
      const { data } = await NetworkContent.getArchivedTasks();
      commit('setArchivedTasks', data.tasks || []);
      commit('setMinCount', data.minCount ?? 3);
    },
    async getCreatedTasks({ commit }) {
      const { data } = await NetworkContent.getCreatedTasks();
      commit('setInvolvedKssUsers', data.involvedUsers || []);
      commit('setCreatedTasks', data.tasks || []);
      commit('setMinCount', data.minCount ?? 3);
    },
    async getKssParticipants({ commit }, loggedInName) {
      const { data } = await NetworkContent.getParticipants();
      commit('setKssParticipants', {
        users: data.users,
        loggedInName,
      });
    },
    async createKssTask({
      commit,
      dispatch,
    }, taskData) {
      const { data } = await NetworkContent.createKssTask(taskData);
      if (data.success) {
        commit('resetKssFormValues');
        commit('removeKssParticipants');
        commit('removeKssTeams');
        commit('resetInviteEmail');
        commit('resetKssRecurringTaskValues');
        commit('initRecurringDays');
        commit('setSimilarTasks', null);
        dispatch('getCreatedTasks');
        dispatch('getArchivedTasks');
        dispatch('getTeams');
        dispatch('getKssParticipants');
      } else {
        commit('setSimilarTasks', data.similarTasks);
      }
    },
    async deleteKssTask({ dispatch }, taskData) {
      // Migrated to Monorepo endpoint
      // DELETE /content-management-api/schemas/kss/assessments/:seriesId
      // seriesId is the primary identifier for KSS series in Monorepo
      await NetworkContent.deleteKssTask(taskData);
      dispatch('getCreatedTasks');
    },
    async endKssSeries({ dispatch }, taskData) {
      const seriesId = taskData.seriesId || taskData._id;
      await NetworkContent.endKssSeries(seriesId);
      dispatch('getCreatedTasks');
    },
    async updateKssTask({ dispatch }, taskData) {
      // Migrated to Monorepo endpoint
      // PUT /content-management-api/schemas/kss/assessments/:seriesId
      // seriesId is the primary identifier for KSS series in Monorepo
      const seriesId = taskData.seriesId || taskData._id;
      await NetworkContent.updateKssTask(seriesId, taskData);
      dispatch('getCreatedTasks');
    },
    async cancelKssTask(_, data) {
      await NetworkAssessment.cancelAssessment(data);
    },
    async updateTaskEventsStatus(_, data) {
      await NetworkContent.updateTaskEventsStatus(data);
    },

  },
};
